import { FetchLedgersAPIResponse } from '../../../services/ledger'
import { BaseReducerState, LedgerResponse } from '../../../services'
import { ActionTypes } from '../actions'

export type FetchLedgerState = BaseReducerState & {
  data: LedgerResponse
}

export const initialState: FetchLedgerState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const fetchLedger = (
  state: FetchLedgerState = initialState,
  action: { type: string; res: any }
): FetchLedgerState => {
  switch (action.type) {
    case `${ActionTypes.FETCH_LEDGER}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.FETCH_LEDGER}_SUCCESS`: {
      const { success, data, message } = <FetchLedgersAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.FETCH_LEDGER}_FAILURE`:
      const res = <FetchLedgersAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.FETCH_LEDGER}_RESET`:
      return {
        ...initialState,
      }
  }
  return state
}
